import { createContext, useContext, ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

const DEMO_EMAIL = "demo@kimfloraldesigns.com";

interface DemoContextType {
  isDemoMode: boolean;
}

const DemoContext = createContext<DemoContextType>({ isDemoMode: false });

export function DemoProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const isDemoMode = user?.email === DEMO_EMAIL;

  return (
    <DemoContext.Provider value={{ isDemoMode }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  return useContext(DemoContext);
}
